import React__default, { useState, useCallback } from 'react';
import { useIntl } from '@grandvisionhq/state';
import { logOrderEvent } from '../../../data-layer/orders.js';
import { useGetMyOrderHistory } from '../../hooks/use-get-my-order-history.js';
import OrderList$1 from './OrderList.js';

const INITIAL_ORDERS = 5 // Amount of orders to query on initial page load
;
const ORDER_INTERVAL = 5 // Amount of orders to query when the 'load more' button is pressed
;
/**
 * Make sure that the count from search parameters are valid to pass as a variable to gql
 * - /?count=9    invalid because count it not dividable by `ORDER_INTERVAL`
 * - /?count=abc  invalid because count it is not a number (`NaN`)
 */ const isValidCount = (count)=>count && !isNaN(count) && count % ORDER_INTERVAL === 0
;
const OrderListContainer = ()=>{
    const intl = useIntl();
    const { getLabel , getFormattedLabel , hasLabel  } = intl;
    // TODO: remove this failed orders state when failed orders are included in the orders graph
    const [failedOrders, setFailedOrders] = useState(0);
    /**
   * This useState hook is used to set a static page count when this component mounts.
   * It checks if the URL contains a `count` search param and uses that for the initial query.
   * The `isValidCount` function validates
   */ const url1 = typeof window !== 'undefined' ? new URL(window.location.href) : undefined;
    const count1 = Number(url1 === null || url1 === void 0 ? void 0 : url1.searchParams.get('count'));
    const initialCount = isValidCount(count1) ? count1 : INITIAL_ORDERS;
    const [initialPageSize] = useState(initialCount);
    const onCompleted = useCallback(// This hook is called every time gql completes the request and returns the new data
    (data)=>{
        var ref, ref1, ref2, ref3;
        if (!data) {
            return;
        }
        const orders = ((ref = data.me) === null || ref === void 0 ? void 0 : (ref1 = ref.orders) === null || ref1 === void 0 ? void 0 : ref1.results.length) || 0;
        const newFailedOrders = ((ref2 = data.me) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.orders) === null || ref3 === void 0 ? void 0 : ref3.failures.length) || 0;
        const totalFailedOrders = newFailedOrders + failedOrders;
        if (newFailedOrders > 0) {
            // We need to keep the state because every 'fetchMore' loses the information about the past orders
            setFailedOrders(totalFailedOrders);
        }
        const count = orders + totalFailedOrders;
        if (isValidCount(count)) {
            // Update the url to remember the amount of orders loaded when the browser back button is used
            const url = new URL(window.location.href);
            url.searchParams.set('count', `${count}`);
            window.history.replaceState(null, '', url);
        }
    }, [
        failedOrders
    ]);
    const [{ fetchMore  }, { data: { total , orders: orders1 , loading , error  } ,  }, ] = useGetMyOrderHistory({
        pageSize: initialPageSize,
        offset: 0,
        onCompleted
    });
    const onLoadMoreClick = useCallback(()=>{
        logOrderEvent({
            event_type: 'my_online_orders',
            event: 'show_more_orders_click'
        });
        // All pages are loaded if orderLoaded doesn't exceed total orders
        if (loading || orders1.length >= total) {
            return;
        }
        const url = new URL(window.location.href);
        const count = Number(url.searchParams.get('count'));
        fetchMore({
            variables: {
                limit: INITIAL_ORDERS,
                offset: count
            }
        });
    }, [
        fetchMore,
        loading,
        orders1.length,
        total
    ]);
    const onContactLinkClick = ()=>{
        logOrderEvent({
            event_type: 'my_online_orders',
            event: 'contact_form_click'
        });
    };
    const labels = {
        noHistory: getLabel('account.order.noHistory.message'),
        loadMore: getLabel('account.orders.showMore'),
        error: getFormattedLabel('account.common.error.contact', {
            parseLink: true,
            parseHTML: true
        }),
        productCategories: getLabel('account.orders.productCategories.title'),
        progressLabel: getFormattedLabel('account.orders.pagingStatus', {
            labelData: {
                total,
                loaded: orders1.length
            }
        }),
        contactText: hasLabel('account.orders.footerText') ? getFormattedLabel('account.orders.footerText', {
            parseLink: true,
            openLinksInNewTab: true
        }) : ''
    };
    return /*#__PURE__*/ React__default.createElement(OrderList$1, {
        error: error,
        labels: labels,
        loading: loading,
        orders: orders1,
        ordersLoaded: orders1.length,
        totalOrders: total,
        onLoadMoreClick: onLoadMoreClick,
        onContactLinkClick: onContactLinkClick
    });
};
var OrderList = OrderListContainer;

export { OrderList as default };
//# sourceMappingURL=OrderListContainer.js.map
